var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackIp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 23.53131,
    cy: 24.50526,
    fill: "#E7E3E6",
    r: 23.27273
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.53148,48.50535c-13.23343,0-24-10.76657-24-24s10.76657-24,24-24s24,10.76657,24,24      S36.76491,48.50535,23.53148,48.50535z M23.53148,1.9599c-12.43182,0-22.54545,10.11364-22.54545,22.54545      S11.09966,47.0508,23.53148,47.0508s22.54546-10.11364,22.54546-22.54545S35.9633,1.9599,23.53148,1.9599z",
    fill: "#D2D2D2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.53148,48.50535c-7.79072,0-14.12879-10.76657-14.12879-24s6.33807-24,14.12879-24      c7.79025,0,14.12831,10.76657,14.12831,24S31.32173,48.50535,23.53148,48.50535z M23.53148,1.9599      c-6.98864,0-12.67424,10.11364-12.67424,22.54545S16.54285,47.0508,23.53148,47.0508      c6.98816,0,12.67377-10.11364,12.67377-22.54545S30.51965,1.9599,23.53148,1.9599z",
    fill: "#D2D2D2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#D2D2D2",
    height: 46.54546,
    width: 1.45455,
    x: 22.80422,
    y: 1.23262
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.53148,38.63366c-13.23343,0-24-6.33807-24-14.12831c0-7.79072,10.76657-14.12879,24-14.12879      s24,6.33807,24,14.12879C47.53148,32.2956,36.76491,38.63366,23.53148,38.63366z M23.53148,11.83111      c-12.43182,0-22.54545,5.68561-22.54545,12.67424c0,6.98816,10.11364,12.67377,22.54545,12.67377      s22.54546-5.68561,22.54546-12.67377C46.07694,17.51671,35.9633,11.83111,23.53148,11.83111z",
    fill: "#D2D2D2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#D2D2D2",
    height: 1.45455,
    width: 46.54546,
    x: 0.25877,
    y: 23.77808
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 11.87878,
    cy: 12.23212,
    fill: "#85BD57",
    r: 3.48329
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.21399,
    cy: 13.26819,
    fill: "#EC6E62",
    r: 3.48329
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.87878,
    cy: 35.74246,
    fill: "#FFC966",
    r: 3.48329
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.36362,
    cy: 36.3898,
    fill: "#53B1E2",
    r: 13.10485
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.24161,30.97248h1.8282v10.83464h-1.8282V30.97248z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.36961,31.91769c0.75348,0.6307,1.1319,1.60199,1.1319,2.91469     c0,1.31186-0.38515,2.27306-1.15545,2.88274c-0.7703,0.60968-1.95097,0.9141-3.54203,0.9141h-1.92238v3.17791h-1.8282V30.97248     h3.72031C41.41695,30.97248,42.61445,31.28783,43.36961,31.91769z M42.07457,36.3898     c0.36665-0.38767,0.55165-0.9553,0.55165-1.70542c0-0.74844-0.23378-1.27822-0.69798-1.58853     c-0.46588-0.30946-1.19413-0.46504-2.18644-0.46504h-1.86015v4.34008h2.12421     C41.01835,36.97089,41.70792,36.77747,42.07457,36.3898z",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackIp);
export default __webpack_public_path__ + "static/media/stack_ip.1cbe4881ec8824a04a9e63426739b354.svg";
export { ForwardRef as ReactComponent };